import { axiosSecureInstance } from "./axios";
import { message } from "antd";
import { GET_ALL_INDUSTRY_TYPE,GET_SINGLE_INDUSTRY_TYPE,CREATE_INDUSTRY_TYPE,UPDATE_SINGLE_INDUSTRY_TYPE,DELETE_SINGLE_INDUSTRY_TYPE,GET_ALL_INDUSTRY_TYPE_PAGINATED } from "../constants/Api_constants";


export const getAllIndustryType = async (setIndustryTypes) => {
    try {
        const response = await axiosSecureInstance.get(GET_ALL_INDUSTRY_TYPE());
        if (response.status === 200) {
            setIndustryTypes(response.data.data);
            return { success: true, data: response.data.data, message: response?.data?.message };
        }

    } catch (error) {
        return { success: false,  message: error?.response?.data?.message };

    }

};

export const getIndustryTypes = async (currentPage, limit) => {
  try {
    const response = await axiosSecureInstance.get(GET_ALL_INDUSTRY_TYPE_PAGINATED(currentPage, limit));
    const assistantTypes = response?.data?.name || [];
    const count = response?.data?.pages || 1;
    return { success: true, data: assistantTypes, pageCount: count };
  } catch (error) {
    return { success: false, message: error?.response?.data?.message };
  }
};

export const createIndustryType = async (assistantType) => {
  try {
    const response = await axiosSecureInstance.post(CREATE_INDUSTRY_TYPE(), {
      name: assistantType
    });
    return { success: true, data: response?.data?.data?.name, message: response?.data?.message };
  } catch (error) {
    return { success: false, message: error?.response?.data?.message };
  }
};

export const deleteIndustryType = async (assistantTypeIdToDelete) => {
  try {
    const response = await axiosSecureInstance.delete(DELETE_SINGLE_INDUSTRY_TYPE(assistantTypeIdToDelete));
    return { success: true, message: response?.data?.message };
  } catch (error) {
    return { success: false, message: error?.response?.data?.message };
  }
};

export const getIndustryTypeById = async (id) => {
  try {
    const response = await axiosSecureInstance.get(GET_SINGLE_INDUSTRY_TYPE(id));
    return { success: true, data: response?.data?.data?.name, message: response?.data?.message};
  } catch (error) {
    return { success: false, message: error?.response?.data?.message };
  }
};

export const updateIndustryType = async (assistantTypeIdToEdit, updatedData) => {
  try {
    const response = await axiosSecureInstance.patch(UPDATE_SINGLE_INDUSTRY_TYPE(assistantTypeIdToEdit), updatedData);
    return { success: true, data: response?.data?.data?.name, message: response?.data?.message };
  } catch (error) {
    return { success: false, message: error?.response?.data?.message };
  }
};
